<template>
  <div ref="modal" class="modal fade" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Allocate Time to Tasks</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
          ></button>
        </div>

        <div class="modal-body">
          <div class="mb-3">
            <h6 class="mb-3">Tasks</h6>

            <div
              v-for="(task, index) in tasks"
              :key="task.id"
              class="row align-items-center mb-3 border-bottom pb-2"
            >
              <div class="col-md-6">
                <span class="fw-medium">{{ task.name }}</span>
              </div>
              <div class="col-md-4">
                <div class="input-group input-group-sm">
                  <input
                    type="number"
                    min="0"
                    class="form-control"
                    v-model.number="task.minutes"
                  />
                  <span class="input-group-text">mins</span>
                </div>
              </div>
              <div class="col-md-2 text-end">
                <button
                  class="btn btn-outline-danger btn-sm"
                  @click="removeTask(index)"
                >
                  Remove
                </button>
              </div>
            </div>
          </div>

          <!-- Add Task -->
          <div class="row mb-4">
            <div class="col-md-8">
              <input
                type="text"
                class="form-control"
                placeholder="New task name"
                v-model="newTask"
              />
            </div>
            <div class="col-md-4">
              <button class="btn btn-outline-primary w-100" @click="addTask">
                Add Task
              </button>
            </div>
          </div>

          <!-- Visualization -->
          <div class="bg-light p-3 rounded">
            <div class="d-flex justify-content-between mb-1">
              <small class="fw-semibold">Allocation Overview</small>
              <small>{{ allocatedPercent }}% Allocated</small>
            </div>

            <div class="progress" style="height: 22px">
              <div
                v-for="(task, i) in tasks"
                :key="task.id"
                class="progress-bar"
                :class="barColor(i)"
                :style="{ width: taskPercent(task) + '%' }"
              >
                {{ taskPercent(task) }}%
              </div>

              <div
                class="progress-bar bg-light text-dark"
                :style="{ width: remainingPercent + '%' }"
              >
                {{ remainingPercent }}% Free
              </div>
            </div>

            <div class="d-flex justify-content-between mt-3">
              <span>Total Allocated:</span>
              <span
                >{{ formatTime(totalAllocated * 60) }} ({{
                  allocatedPercent
                }}%)</span
              >
            </div>
            <div class="d-flex justify-content-between">
              <span>Not Allocated:</span>
              <span :class="remainingClass">
                {{ formatTime(remainingTime * 60) }} ({{ remainingPercent }}%)
              </span>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            :disabled="remainingTime < 0"
          >
            Save Allocation
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const bootstrap = require("bootstrap");

export default {
  name: "TimeAllocatorModal",
  props: {
    modelValue: Object,
  },
  data() {
    return {
      myModal: undefined,
      newTask: "",
      tasks: [
        { id: 1, name: "Design Wireframes", minutes: 2 },
        { id: 2, name: "Develop Feature A", minutes: 3 },
      ],
    };
  },

  computed: {
    totalTime() {
      return this.modelValue?.duration ?? 0;
    },
    totalAllocated() {
      return this.tasks.reduce((sum, t) => sum + (t.minutes || 0), 0) * 60;
    },

    remainingTime() {
      return this.totalTime - this.totalAllocated;
    },

    allocatedPercent() {
      return Math.min(
        100,
        Math.round((this.totalAllocated / this.totalTime) * 100)
      );
    },

    remainingPercent() {
      return Math.max(0, 100 - this.allocatedPercent);
    },

    remainingClass() {
      return this.remainingTime < 0
        ? "text-danger fw-semibold"
        : "text-success fw-semibold";
    },
  },

  methods: {
    showModal() {
      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
      this.load();
    },
    formatTime(seconds, secunds = false) {
      if (seconds >= 60) {
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        if (secunds) {
          const remainingSeconds = seconds % 60;
          return `${hours}:${minutes
            .toString()
            .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
        }
        return `${hours}:${minutes.toString().padStart(2, "0")}`;
      } else {
        return `${seconds} s`;
      }
    },
    barColor(index) {
      const palette = [
        "bg-primary",
        "bg-success",
        "bg-warning",
        "bg-info",
        "bg-danger",
        "bg-secondary",
        "bg-dark",
      ];
      return palette[index % palette.length];
    },
    taskPercent(task) {
      if (!task.minutes) return 0;
      return Math.round(((task.minutes * 60) / this.totalTime) * 100);
    },

    addTask() {
      if (!this.newTask.trim()) return;

      this.tasks.push({
        id: Date.now(),
        name: this.newTask,
        minutes: 0,
      });

      this.newTask = "";
    },

    removeTask(index) {
      this.tasks.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.progress-bar {
  font-size: 0.75rem;
}
</style>
